import { TextInput } from "../../../../../../../common/adapters/primaries/form/inputs/text.input";
import React from "react";
import { SocialPageInfo } from "../../../../../../../company/domain/entity/socialPageInfo";

interface Props{
    account: SocialPageInfo
    textPost: string
    picturePost: string
    changeText: (text: string) => void
}
export const PreviewInstagramPost = (props:Props): JSX.Element =>{
    return(
        <div className={'preview_share'}>
         <div className={'account'}>
                <img src={props.account.image} className={'account_icon'}/>
                <div className={'account_name'}>{props.account.name}</div>
            </div>
            <img src={props.picturePost} className={'preview-img'}/>
            <TextInput type={'text'} numberOfLines={2} className={'title_post'} label={''}
                       error={false} value={props.textPost}
                       raiseUpdates={(text: string) => props.changeText(text)}/>
        </div>
    )
}
